import Vue from 'vue'
import { Event } from './data-models/event'
import { Host } from './data-models/host'

export const Store = new Vue({
  data: {
    events: {},
    host: new Host()
  },
  methods: {
    clear () {
      this.clearHost()
      this.clearEvents()
    },
    setHost (host) {
      if (host instanceof Host) this.host = host
    },
    clearHost () {
      this.host = new Host()
    },
    addEvents (events) {
      for (let eventId in events) {
        if (!events.hasOwnProperty(eventId)) continue
        if (!(events[eventId] instanceof Event)) delete events[eventId]
      }
      this.events = Object.assign({}, this.events, events)
    },
    addEvent (event) {
      if (!event.id) return

      let eventObject = {}
      eventObject[event.id] = event
      this.addEvents(eventObject)
    },
    clearEvents () {
      this.events = Object.assign({})
    },
    setStripeAccount (stripeAccount) {
      this.host.stripeAccount = stripeAccount
    }
  }
})
